export default "__VITE_ASSET__59278ce1__"